export const getTitleCaseStringFromInputString = (str: string) =>
  str
    .toLowerCase()
    .split(' ')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')

export const generateHashCode = (str: string) => {
  let hval = 53
  for (let i = 0; i < str.length; i += 1) {
    hval ^= str.charCodeAt(i)
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24)
  }
  return hval >>> 0
}

export const generateRandomString = () => {
  return `_${Math.random().toString(36).substr(2, 9)}`
}
